import { IconLink } from '@/components/Atoms/IconLink/IconLink';
import Popout from '@/components/Icons/Popout';
import { LaunchEventButton } from '@/components/Molecules/LaunchEventButton/LaunchEventButton';
import { RegisterButton } from '@/components/Molecules/RegisterButton/RegisterButton';
import useTranslation from '@/hooks/useTranslation';
import type { IEvent, IEventWebinar } from '@/interfaces';
import { ContentType } from '@/interfaces';
import { calculateLifeCycleState, LifeCycleState } from '@/utils/eventUtils';
import type { FC } from 'react';

export const EventCTA: FC<{ event: IEvent }> = ({ event }) => {
    const { t } = useTranslation('common');
    const currentLifecycleState = calculateLifeCycleState(event);
    if (event.type === ContentType.webinar && (event as IEventWebinar).subscriptionState) {
        if (currentLifecycleState === LifeCycleState.live) {
            return <LaunchEventButton eventId={event.id} />;
        }
        return <RegisterButton subscriptionState={(event as IEventWebinar).subscriptionState} eventId={event.id} />;
    }

    // todo #SEMR - temporary until SEMR support registration and launch links
    if (event.joinUrl && currentLifecycleState === LifeCycleState.live) {
        return (
            <IconLink
                icon={<Popout />}
                text={t('Event.LaunchEventButton.launchEvent')}
                href={event.joinUrl}
                target="_blank"
                rel="noopener noreferrer"
            />
        );
    }

    if (event.registrationUrl) {
        return (
            <IconLink
                icon={<Popout />}
                text={t('Event.Registration.registration')}
                href={event.registrationUrl}
                target="_blank"
                rel="noopener noreferrer"
            />
        );
    }

    return null;
};
